import { Dispatch, SetStateAction, useEffect, useState } from "react";

export type useDebounceProps = (
  initial: string,
  delay?: number
) => [string, Dispatch<SetStateAction<string>>, string, (value: string) => void]

const useDebounce: useDebounceProps = (initial, delay= 500) => {
  const [instant, setInstant] = useState(initial);
  const [delayed, setDelayed] = useState(initial)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDelayed(instant)
    }, delay)

    return () => clearTimeout(timeoutId)
  }, [instant])

  const forceNewValue = (value: string ) => {
    setDelayed(value)
    setInstant(value)
  }

  return [delayed, setInstant, instant, forceNewValue]
};

export default useDebounce
